import logo from "../assets/images/logo.png"
import logo_c from "../assets/images/company_logo.png"
export default {
		home: {
				welcome1: '谛视者',
				welcome2: '书库',
				logo,
				lang: [
						{
								title: '繁體中文',
								key: 'zh-tw'
						},
						{
								title: '简体中文',
								key: 'zh-cn'
						},
						{
								title: 'English',
								key: 'en'
						},
						{
								title: '日本語',
								key: 'ja'
						},
						{
								title: '한국어',
								key: 'ko'
						}

				],
				reward: "专属奖励",
				welfare: "限定福利",
				up: "查看活动说明",
				activity: {
						time: {
								title: "活动时间：",
								year_start: "2019年 ",
								year_end: "2020年 ",
								month_day_start: "11月21日 10:00",
								month_day_end: "02月03日 10:00",
						},
						content: {
								title: "活动方式：",
								way: [
										`1、点击【专属奖励】即可领取《Sdorica 万象物语》X《地下城物语》联动专属奖励一份。 `,
										`2、点击【限定福利】进入联动活动页面领取更多奖励。 `,
										`3、本页面仅可领取联动活动《Sdorica 万象物语》奖励内容。 `,
										`4、欲领取《地下城物语》奖励请前往《地下城物语》相关活动页。 `,
										`5、每一个SID中的个别书库帐号均可领取一次奖励，点击领取后奖励将直接发送到当前登录的书库中。 `,
										`6、奖励将透过游戏内信件发送，信件有效期为30天，领取完毕后请确认是否领取。 `
								]
						}
				}
		},
		welfare: {
				back: "回到首页",
				welcome1: '谛视者',
				welcome2: '书库',
				gumballs_activity: {
						time: {
								title: "活动时间：",
								year_start: "2019年 ",
								year_end: "2020年 ",
								month_day_start: "11月21日 10:00",
								month_day_end: "02月03日 10:00",
						},
						content: {
								title: "活动方式：",
								way: [
										`1、点击【领取《地下城物语》活动序号】即可领取《地下城物语》联动限定活动序号。 `,
										`2、点击【下载《地下城物语》】下载并安装《地下城物语》。 `,
										`3、开启并前往《地下城物语》大地图>右上角齿轮设置>密令兑换`
								]
						},
						get_code: "领取《地下城物语》活动序号",
						download: "下载《地下城物语》"
				},
				sdorica_activity: {
						time: {
								title: "活动时间：",
								year_start: "2019年 ",
								year_end: "2020年 ",
								month_day_start: "11月21日 10:00",
								month_day_end: "02月03日 10:00",
						},
						content: {
								title: "活动方式：",
								way: [
										`1、前往《地下城物语》联动活动页领取《Sdorica 万象物语》联动限定活动序号。 `,
										`2、在以下输入框中输入，并点击领取。 `,
										`3、每一个SID中的个别书库帐号仅可领取一次。 `,
										`4、请确认书库名称、游戏昵称无误后再进行领取，领取成功后该序号不得再次使用。 `,
										`5、奖励内容将透过游戏内信件发送，信件有效期为30天，领取完毕后请确认是否领取。 `
								]
						},
						label: "活动序号：",
						placeholder: "点击输入活动序号",
						noEnter_placeholder: "请先输入活动序号",
						get_welfare: "领取《Sdorica 万象物语》限定福利",
						got_welfare: "已领取限定福利"
				}
		},
		get_reward: {
				done: {
						title: "领取成功！",
						content: ["奖励已寄送至游戏中信箱，","请至游戏中确认"]
				},
				failed: {
						title: "领取失败！",
						retry:"请重试"
				},
		},
		code_config: {
				title: "《地下城物语》限定活动序号",
				copy: "复制",
				download: "下载《地下城物语》，前往对应的活动页使用",
				success: '复制成功'

		},
		rightCode: '请输入正确的活动序号',
		messageFailed: "已领取，请勿重复领取",
		footer: {
				logo: logo_c,
				company: "© 2019 Rayark Inc. All rights reserved.",
				caseNumber: "",
				copyright: "",
				publicSecurityRecordNumber: "",
				wangwen: ""

		},
		resize: '请将手机/平板调整为直向观看。 ',
		notFound: '抱歉，页面不存在。 ',
		network_error: {
			INVALID_REWARD_TYPE: '非正确的奖励',
			EXIST_REWARD_RECORD: '已领取奖励',
			INVALID_CODE: '该序号验证失败',
			CODE_USED: '该序号已被使用',
			GAMEDATA_INVALID_VALUE: '领取失败',
			OTHER:'领取失败',
			NO_TOKEN:'本页面需要从游戏内点击活动宣传图进入'
		}
}